import { createStore } from 'vuex'

export default createStore({
  state: {
    actionurl: null,
    configurl: null,
    preflighturl: null,
    recaptchaSiteKey: null,
    recaptchaPreflightAction: null,
    bID: 0,
    questions: [],
  },
  mutations: {
    updateActionUrl(state, actionurl) {
      state.actionurl = actionurl
    },
    updateConfigUrl(state, configurl) {
      state.configurl = configurl
    },
    updatePreflightUrl(state, preflighturl) {
      state.preflighturl = preflighturl
    },
    updateRecaptchaSiteKey(state, recaptchaSiteKey) {
      state.recaptchaSiteKey = recaptchaSiteKey
    },
    updateRecaptchaPreflightAction(state, recaptchaPreflightAction) {
      state.recaptchaPreflightAction = recaptchaPreflightAction
    },
    updateBID(state, bID) {
      state.bID = bID
    },
  },
  getters: {},
  actions: {},
})
